module.exports = __webpack_public_path__ + "img/1662105414657.6ba869a9.png";